import React from "react";
import { useAuth } from "../Store/AuthContext";

export default function GoogleMapSection() {
  const { webSetting } = useAuth();
  return (
    <>
      {webSetting?.map &&
        typeof webSetting.map === "string" &&
        webSetting.map.trim() !== "" && (
          <section className="  ">
            <div className="map-area">
              <div className="map-content">
                <iframe
                  src={webSetting.map}
                  width="100%"
                  height="450"
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="map Google"
                ></iframe>
              </div>
            </div>
          </section>
        )}
    </>
  );
}
